import { AdminStatistics, CardStatistics } from '@/types/statistic';
import { api } from '@/utils/axios';

interface ApiResponse<T> {
  message: string;
  data: T;
}

export const getAdminStatistics = async (): Promise<
  ApiResponse<AdminStatistics>
> => {
  const response = await api.get('/app-web/statistics/admin');
  return response.data;
};

export const getCardStatistics = async (
  slug: string,
): Promise<ApiResponse<CardStatistics>> => {
  const response = await api.get(`/app-web/statistics/card/${slug}`);
  return response.data;
};
